import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  Snackbar,
  Box,
} from '@mui/material';
import { solicitarReembolso } from '../../../services/pedidoReembolsoService';

export interface SolicitarReembolsoDialogProps {
  open: boolean;
  pagamentoId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const SolicitarReembolsoDialog: React.FC<SolicitarReembolsoDialogProps> = ({
  open,
  pagamentoId,
  onClose,
  onSuccess,
}) => {
  const [motivoSolicitacao, setMotivoSolicitacao] = useState('');
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error';
  }>({ open: false, message: '', severity: 'success' });

  const handleSubmit = async () => {
    if (!motivoSolicitacao.trim()) return;
    setSaving(true);
    try {
      await solicitarReembolso({ pagamentoId, motivoSolicitacao: motivoSolicitacao.trim() });
      setMotivoSolicitacao('');
      onSuccess();
      onClose();
    } catch (e: any) {
      const msg = e?.graphQLErrors?.[0]?.message || e?.message || 'Erro ao solicitar reembolso.';
      setSnackbar({ open: true, message: msg, severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  const handleCloseSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

  const handleClose = () => {
    if (saving) return;
    setMotivoSolicitacao('');
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Solicitar Reembolso</DialogTitle>
        <DialogContent dividers>
          <Box display="flex" flexDirection="column" gap={2} pt={1}>
            <TextField
              label="Motivo da solicitacao"
              value={motivoSolicitacao}
              onChange={(e) => setMotivoSolicitacao(e.target.value)}
              fullWidth
              size="small"
              multiline
              rows={3}
              required
              disabled={saving}
              InputLabelProps={{ shrink: true }}
              placeholder="Informe o motivo do pedido de reembolso"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={saving}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={saving || !motivoSolicitacao.trim()}
          >
            {saving ? 'Solicitando...' : 'Solicitar Reembolso'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SolicitarReembolsoDialog;
